import ChannelMonitoringPage from './ChannelMonitoringPage';
import './assets/channel-monitoring.scss'

export default ChannelMonitoringPage;